/** Configuração declarativa do mobile tabbar. */
export const MOBILE_TABBAR_UI_CONFIG = {
  maxVisibleTabs: 3,
  defaultIconTone: "bg-gray-100 text-gray-700",
  surfaces: {
    solid: {
      container:
        "relative z-40 w-full border-t border-gray-200 bg-gray-50",
      inner: "flex h-[var(--mobile-tabbar-height)] items-stretch px-1 py-1",
      item: "flex flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 rounded-lg px-1 py-1 transition-colors hover:bg-black/5",
      itemActive: "text-blue-600",
      itemInactive: "text-gray-500",
      label: "text-xs font-medium leading-none",
      labelActive: "text-blue-600",
      labelInactive: "text-gray-500",
      iconWrap: "inline-flex rounded-lg p-1.5",
      iconSize: "h-5 w-5",
    },
    floating: {
      container:
        "fixed bottom-0 left-0 right-0 z-40 w-full rounded-t-2xl border-t border-gray-200 bg-gray-50 shadow-[0_-2px_10px_rgba(0,0,0,0.1)] transition-transform duration-200",
      containerHidden: "translate-y-full",
      inner: "flex h-[var(--mobile-tabbar-height)] items-stretch px-1 py-1",
      item: "flex flex-1 cursor-pointer flex-col items-center justify-center gap-0.5 rounded-lg px-1 py-1 transition-colors hover:bg-black/5",
      itemActive: "text-blue-600",
      itemInactive: "text-gray-500",
      label: "text-xs font-medium leading-none",
      labelActive: "text-blue-600",
      labelInactive: "text-gray-500",
      iconWrap: "inline-flex rounded-lg p-1.5",
      iconSize: "h-5 w-5",
    },
  },
};
